import { Route as BaseRoute, RouteProps } from 'react-router-dom'
import { useGetCountries } from 'shared/hooks/useGetCountries'
import { useValidation } from 'shared/hooks'
import { MobilePage } from 'shared/components'
import { useRedirectToShop } from './Route.utils'

const Route = (props: RouteProps) => {
  useValidation()
  useGetCountries()

  const shouldRedirect = useRedirectToShop()

  return shouldRedirect ? <MobilePage /> : <BaseRoute {...props} />
}

export default Route
